import { useState, useEffect } from "react";

import { ReactComponent as MailIcon } from "_assets/icons/mail.svg";
import { ReactComponent as LockIcon } from "_assets/icons/lock.svg";

import Button from "_shared/Button";
import TextInput from "_shared/Input/Text";

import { axios } from "setups/axios";

const Login = () => {
  const [data, setData] = useState({
    SAP_ID: "",
    pin: "",
  });

  const [error, setError] = useState("");

  const validate = () => {
    let error = "";

    if (!data.SAP_ID || !data.pin)
      error = "Please provide both SAP ID and Password.";

    setError(error);

    if (error) return false;

    return true;
  };  

  const loginHandler = async () => {
    if(!validate()) return;

    const res = await axios()({
      url: `/api/v1/login`,
      method: "POST",
      data,
    }).catch((error) => {
      console.log(error.response);

      setError(error?.response?.data?.message);

      return;
    });

    if (res) {
      const { data } = res.data;

      localStorage.setItem("token", data.token);

      location.reload();
    }

    console.log(res?.data);
  };

  return (
    <div className="login-container">
      {error && <div className="error-message">{error}</div>}

      <TextInput
        icon={<MailIcon />}
        placeholder="SAP ID"
        value={data.SAP_ID}
        setValue={(SAP_ID) => setData({ ...data, SAP_ID })}
      />

      <TextInput
        icon={<LockIcon />}
        type="password"
        placeholder="Pin"
        value={data.pin}
        setValue={(pin) => setData({ ...data, pin })}
      />

      <br />

      <Button text="Login" action={loginHandler} />
    </div>
  );
};

export default Login;
